import { TDropdown } from "../../shared/modal";
import { JobType, ReqPriority, ReqTerm, ReqType } from "../requirement-my-sales/modal";

export type TRequirement = {
    id?: number;
    reqType: ReqType;
    vendorCompanyId: number;
    vendorCompanyName: string;
    contactPersonId: number;
    contactPersonName: string;
    jobTitle: string;
    duration: number;
    rate: number;
    jobType: JobType;
    cityId?: number;
    cityName?: string;
    stateId?: number;
    stateName?: string;
    countryId?: number;
    countryName?: string;
    endClient: string;
    term: ReqTerm;
    noOfPositions: number;
    industryId: number;
    industryName: string;
    skillCategoryId: number;
    skillCategory: string;
    priority: ReqPriority;
    interviewProcessId: number;
    interviewProcess: string;
    requiredSkill: string;
    jobDescription: string;
    isTravelRequired: boolean;
    postedBy: string;
    postedOn: string;
    isHold: boolean;
    visa?: TDropdown[];
    allocations?: TDropdown[];
}

export type TReqFilter = {
    fromDate: Date | string | null;
    toDate: Date | string | null;
    id: number | null;
    reqType: ReqType | null;
    term: ReqTerm | null;
    priority: ReqPriority | null;
    jobType: JobType | null;
    industryId: number | null;
    skillCategoryId: number | null;
    interviewProcessId: number | null;
    noOfPositions: number | null;
}

export const EmptyReqFilter: TReqFilter = {
    fromDate: new Date(),
    toDate: new Date(),
    id: null,
    reqType: null,
    term: null,
    priority: null,
    jobType: null,
    industryId: null,
    skillCategoryId: null,
    interviewProcessId: null,
    noOfPositions: null,
}
